import { useTranslation } from 'react-i18next'

import { toast } from '@/hooks/useToast'
import { formatDate } from '@/utils/format-date'

import useBulkScheduleArchiveStudents from '../mutations/useBulkScheduleArchiveStudents'

const useScheduleArchiveStudents = ({
  onSuccess,
  studentName
}: {
  onSuccess: () => void
  studentName?: string
}) => {
  const { t } = useTranslation('students')

  return useBulkScheduleArchiveStudents({
    onSuccess: ({
      successfully_scheduled,
      unsuccessfully_scheduled,
      cancelled_schedule,
      archiveDate
    }) => {
      if (successfully_scheduled > 0) {
        toast({
          variant: 'success',
          title: studentName
            ? t('toast.student-scheduled-archive', {
                NAME: studentName
              })
            : t('toast.students-scheduled-archive', {
                count: successfully_scheduled
              }),
          description: t('toast.student-will-be-archived', {
            count: successfully_scheduled,
            DATE: formatDate(archiveDate)
          })
        })
      }

      if (unsuccessfully_scheduled > 0) {
        toast({
          variant: 'error',
          title: studentName
            ? t('toast.student-schedule-archive-failed', {
                NAME: studentName
              })
            : t('toast.students-schedule-archive-failed', {
                count: unsuccessfully_scheduled
              })
        })
      }

      if (cancelled_schedule > 0 && studentName) {
        toast({
          variant: 'success',
          title: t('toast.student-undo-schedule-archive', { NAME: studentName })
        })
      }
      onSuccess()
    },
    onError: ({ ids, archiveDate }) => {
      if (archiveDate) {
        toast({
          variant: 'error',
          title: studentName
            ? t('toast.student-archived-failed', {
                NAME: studentName
              })
            : t('toast.students-archived-failed', {
                count: ids.length
              })
        })
      } else {
        toast({
          variant: 'error',
          title: t('toast.student-undo-archived-failed', {
            NAME: studentName
          })
        })
      }
    }
  })
}

export default useScheduleArchiveStudents
